<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  Отечественный производитель уникальных по своим свойствам
                  масел и смазок - компания «КУППЕР» присутствует на российском
                  рынке с 2012 года. Сегодня мы - это динамично развивающаяся
                  организация, основной вид деятельности которой - разработка,
                  производство и реализация инновационных смазочных материалов.
                </p>
                <p>
                  Специалисты компании стояли у истоков создания смазочных
                  материалов и более чем 20 лет работ по созданию и внедрению
                  технологии защиты от износа, накопили огромный опыт в
                  изготовлении всей линейки масел и смазок. Наша продукция
                  производится из компонентов отечественного производства,
                  включая уникальный пакет присадок.
                </p>
                <p>
                  В настоящий момент компания «КУППЕР» имеет в гамме своей
                  продукции весь спектр смазочных материалов: от самых жидких
                  гидравлических масел до консистентных смазок, что позволяет
                  удовлетворить потребности наших клиентов во всех сферах
                  промышленности. Вся линейка наших продуктов отвечает самым
                  высоким требованиям по качеству и находится в доступном
                  ценовом сегменте.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+74954313243"
                          class="ViewPromo__advantage-contact-link"
                          >+7 (495) 431-32-43</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы поставок</h4>
                    <p>ООО "КУППЕР"</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «КУППЕР»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1351,
    productId: 2201,
    name: 'ООО «КУППЕР»',
    inn: '7716732008 ',
  }),
};
</script>
